import React from "react";
import styles from "Components/UI/Payslip/Template/TemplatePayslip.module.css";
import PropTypes from "prop-types";
import { format } from "date-fns";
const MonthlyEdit = ({ payrollData, companyDetails }) => {
  
  return (
    <div className={`mb-5 ${styles.payslip}`}>
      <div className={styles.header}>
        {/* <ImageWithBasePath src="assets/img/logo.png" alt="Logo" /> */}
        <img
          src={`data:image/png;base64,${companyDetails?.companyLogo}`}
          alt="Compnay Logo"
          style={{ width: "110px" }}
        />
        <div className={styles["header-text"]}>
          <h2 className="mb-2">{companyDetails?.companyName.toUpperCase()}</h2>
          <h6>
            {companyDetails?.address1}
            {companyDetails?.address2}
            {companyDetails?.address3}
            {companyDetails?.country} - {companyDetails?.zipCode}
          </h6>
          <h6>
            Ph : {companyDetails?.phoneNo} | Email : {companyDetails?.email}
          </h6>
        </div>
      </div>
      <table className={`${styles.details}`}>
        <tr>
          <td>Employee Name</td>
          <td>{payrollData?.fullName}</td>
          <td>Pay Period Begin Date</td>
          <td>{format(new Date(payrollData?.fromDate), "dd-MM-yyyy")}</td>
        </tr>

        <tr>
          <td>Employee ID</td>
          <td>{payrollData?.uniqueID}</td>
          <td>Pay Period End Date</td>
          <td>{format(new Date(payrollData?.toDate), "dd-MM-yyyy")}</td>
        </tr>

        <tr>
          <td>IC No / FIN No</td>
          <td>{payrollData?.icno}
            {/* {payrollData?.residentialType === "OS"
              ? payrollData?.finNumber
              : payrollData?.icno} */}
          </td>
          <td>Pay Date</td>
          <td>{format(new Date(payrollData?.processDate), "dd-MM-yyyy")}</td>
        </tr>
        <tr>
          <td>DOB / Age</td>
          <td>{payrollData?.hpno}</td>
          <td>Date of Joining</td>
          <td>
            {payrollData?.joinDate !== "" &&
              format(new Date(payrollData?.joinDate), "dd-MM-yyyy")}
          </td>
        </tr>
        <tr>
          <td>Job Title</td>
          <td>{payrollData?.jobTitle}</td>
          <td></td>
          <td></td>
        </tr>
      </table>

      <div className={styles["wrapper"]}>
        <div className={styles["table-container"]}>
          <table className={`${styles.details2}`}>
            <tr>
              <th className={`${styles["table-header"]} mb-2`} colSpan={2}>
                <h4 style={{ marginBottom: "0px" }}>Earning (SGD)</h4>
              </th>
            </tr>

            {payrollData?.earningsList.map(
              (pd, _k) =>
                Number(pd?.amount) !== Number(0) && (
                  <tr key={_k}>
                    <td className={styles.label}>{pd?.description}</td>
                    <td className={styles.value}>
                      {Number(pd?.amount).toFixed(2)}
                    </td>
                  </tr>
                )
            )}
          </table>
          {/* {payrollData?.earningsList.map(
             (pd, _k) =>
               pd?.amount > 0 && (
                 <div className={styles.payrollListRow} key={_k}>
                   <span className={styles.label}>{pd?.description}</span>
                   <span className={styles.value}>
                     {Number(pd?.amount).toFixed(2)}
                   </span>
                 </div>
               )
           )} */}
          <div className={styles["footer"]}>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>Total Earning</span>
              <span className={styles.value}>
                {Number(payrollData?.totalEarning).toFixed(2)}
              </span>
            </div>
          </div>

          <div className={styles["footer-2"]}>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>
                <strong>Employer Contribution</strong>
              </span>
              <span className={styles.value}>&nbsp;</span>
            </div>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>CPF</span>
              <span className={styles.value}>
                {Number(payrollData?.employerCpf).toFixed(2)}
              </span>
            </div>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>FWL</span>
              <span className={styles.value}>0.00</span>
            </div>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>SDL</span>
              <span className={styles.value}>
                {Number(payrollData?.sdlAmount).toFixed(2)}
              </span>
            </div>
          </div>
        </div>

        <div className={styles["table-container"]}>
          <table className={`${styles.details2}`}>
            <tr>
              <th className={`${styles["table-header"]} mb-2`} colSpan={2}>
                <h4 style={{ marginBottom: "0px" }}>Deductions (SGD)</h4>
              </th>
            </tr>

            {payrollData?.deductionsList.map(
              (pd, _k) =>
                Number(pd?.amount) !== Number(0) && (
                  <tr key={_k}>
                    <td className={styles.label}>{pd?.description}</td>
                    <td className={styles.value}>
                      {Number(pd?.amount).toFixed(2)}
                    </td>
                  </tr>
                )
            )}
          </table>

          {/* <div className={`${styles["table-header"]} mb-2`}>
             <h4>Deductions (SGD)</h4>
           </div>
           {payrollData?.deductionsList.map(
             (pd, _k) =>
               pd?.amount > 0 && (
                 <div className={styles.payrollListRow} key={_k}>
                   <span className={styles.label}>{pd?.description}</span>
                   <span className={styles.value}>
                     {Number(pd?.amount).toFixed(2)}
                   </span>
                 </div>
               )
           )} */}

          <div className={styles["footer"]}>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>Total Deduction</span>
              <span className={styles.value}>
                {Number(payrollData?.totalDeduction).toFixed(2)}
              </span>
            </div>
          </div>

          <div className={styles["footer-2"]}>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>
                <strong>Payment Information</strong>
              </span>
              <span className={styles.value}>&nbsp;</span>
            </div>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>Payment Mode</span>
              <span className={styles.value}>{payrollData?.paymentMode}</span>
            </div>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>Reference Number</span>
              <span className={styles.value}>&nbsp;</span>
            </div>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>&nbsp;</span>
              <span className={styles.value}>&nbsp;</span>
            </div>
            {/* <div className={styles.payrollListRow}>
               <span className={styles.label}>Net Salary</span>
               <span>{payrollData?.netPay}</span>
             </div> */}
            {/* <div className={styles.payrollListRow}>
               <span className={styles.label}>YTD Employee Salary</span>
               <span>695.90</span>
             </div> */}
          </div>
        </div>
      </div>

      {/* <div className={styles["table-container"]}> */}
      <div className="">
        <div
          className={styles.payrollListRow}
          style={{ justifyContent: "end" }}
        >
          <strong>
            <span className={styles.label}> Basic Pay</span>
            &nbsp;&nbsp;
            <span className={styles.value}>
              {Number(payrollData?.grossSalary).toFixed(2)}
            </span>
          </strong>
        </div>
        <div
          className={styles.payrollListRow}
          style={{ justifyContent: "end" }}
        >
          <strong>
            <span className={styles.label}> Net Pay</span>
            &nbsp;&nbsp;
            <span className={styles.value}>
              {Number(payrollData?.netPay).toFixed(2)}
            </span>
          </strong>
        </div>
      </div>

      {/* <div className={styles.signatureSection}>
         <div className={styles.label}>
           Prepared By : {payrollData?.reviewedBy}
         </div>
         <div className={styles.label}>
           Approved By : {payrollData?.approvedBy}
         </div>
         <div className={styles.label}>
           Received By : {payrollData?.preparedBy}
         </div>
       </div> */}

      {/* <div className={styles["bottom-text"]}>
        <p className="text-center">
          This is computer generated payslip, No Signature is required.
        </p>
      </div> */}
    </div>
  );
};

export default MonthlyEdit;

MonthlyEdit.propTypes = {
  companyDetails: PropTypes.object.isRequired,
  payrollData: PropTypes.object.isRequired,
};
